import React from "react";
import { Box } from "@mui/material";

import CommonInput from "../../../CommonComponents/CommonInput";
import styles from "../AddVendorModal.module.css";

import { fieldLabelStyle, inputSx } from "../AddVendorModal.styles";

const FieldError = ({ error, className = styles.errorText }) =>
  error ? <Box className={className}>{error}</Box> : null;

const VendorInputField = ({ field, value, error, onChange }) => (
  <Box className={styles.fieldWrapper}>
    <CommonInput
      label={field.label}
      name={field.name}
      value={value}
      placeholder={`Enter ${field.label}`}
      required={field.required}
      onChange={onChange}
      removeBackGround
      labelStyle={fieldLabelStyle}
      sx={inputSx}
    />

    <FieldError error={error} />
  </Box>
);

export default VendorInputField;
